module.exports = __webpack_public_path__ + "static/media/COS_CURAE_LAB.3388935d.png";